// Daily Traffic Dashboards Default

export const barChartDataDailyTraffic = [
  {
    name: "כניסות לאפליקציה",
    data: [35, 85, 105],
  },
];

export const barChartOptionsDailyTraffic = {
  chart: {
    toolbar: {
      show: false,
    },
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
    },
  },
  tooltip: {
    enabled: true,
    style: {
      fontSize: "14px",
      fontFamily: "inherit",
    },
    y: {
      formatter: function(value) {
        return value + " כניסות";
      },
    },
    theme: "dark",
    marker: {
      show: true,
    },
  },
  xaxis: {
    categories: [],
    show: true,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: true,
    color: "black",
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
      },
      formatter: function(value) {
        return Math.floor(value).toLocaleString('en-US');
      },
    },
  },
  grid: {
    show: true,
    strokeDashArray: 4,
    borderColor: "rgba(163, 174, 208, 0.2)",
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  //Monthly entries bg - multi-color bars
  colors: ["#18E482", "#4299E1", "#9F7AEA", "#F6AD55", "#38B2AC", "#ED64A6"],
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 0.8,
      opacityFrom: 1,
      opacityTo: 0.7,
      stops: [0, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 8,
      columnWidth: "45%",
      distributed: true,
    },
  },
  legend: {
    show: false,
  },
  states: {
    hover: {
      filter: {
        type: "darken",
        value: 0.9,
      },
    },
  },
};

export const barChartOptionsMonthlyTransfersCount = {
  chart: {
    toolbar: { show: false },
    animations: { enabled: true, easing: 'easeinout', speed: 800 },
  },
  tooltip: {
    enabled: true,
    style: { fontSize: "14px", fontFamily: "inherit" },
    y: {
      formatter: function(value) {
        return value.toLocaleString('en-US') + " העברות";
      },
    },
    theme: "dark",
    marker: { show: true },
  },
  xaxis: {
    categories: [],
    show: true,
    labels: {
      show: true,
      style: { colors: "#A3AED0", fontSize: "14px", fontWeight: "500" },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    show: true,
    color: "black",
    labels: {
      show: true,
      style: { colors: "#A3AED0", fontSize: "12px" },
      formatter: function(value) {
        return Math.floor(value).toLocaleString('en-US');
      },
    },
  },
  grid: {
    show: true,
    strokeDashArray: 4,
    borderColor: "rgba(163, 174, 208, 0.2)",
    yaxis: { lines: { show: true } },
    xaxis: { lines: { show: false } },
  },
  colors: ["#4299E1", "#9F7AEA", "#38B2AC", "#F6AD55", "#ED64A6", "#18E482"],
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 0.8,
      opacityFrom: 1,
      opacityTo: 0.7,
      stops: [0, 100],
    },
  },
  dataLabels: { enabled: false },
  plotOptions: {
    bar: { borderRadius: 8, columnWidth: "45%", distributed: true },
  },
  legend: { show: false },
  states: {
    hover: { filter: { type: "darken", value: 0.9 } },
  },
};

// Consumption Users Reports

export const barChartDataConsumption = [
  {
    name: "PRODUCT A",
    data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
  },
  {
    name: "PRODUCT B",
    data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
  },
  {
    name: "PRODUCT C",
    data: [400, 370, 330, 390, 320, 350, 360, 320, 380],
  },
];

export const barChartOptionsConsumption = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
    theme: "dark",
  },
  xaxis: {
    categories: ["17", "18", "19", "20", "21", "22", "23", "24", "25"],
    show: false,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
    color: "black",
    labels: {
      show: false,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
  },

  grid: {
    borderColor: "rgba(163, 174, 208, 0.3)",
    show: true,
    yaxis: {
      lines: {
        show: false,
        opacity: 0.5,
      },
    },
    row: {
      opacity: 0.5,
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "solid",
    colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
  },
  legend: {
    show: false,
  },
  colors: ["#5E37FF", "#6AD2FF", "#E1E9F8"],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "20px",
    },
  },
};

export const pieChartOptions = {
  labels: ["עובדים 1300", "עובדים 700"],
  colors: ["red", "#6AD2FF", "#EFF4FB"],
  chart: {
    width: "50px",
    id: 1111
  },
  states: {
    hover: {
      filter: {
        type: "none",
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  hover: { mode: null },
  plotOptions: {
    donut: {
      expandOnClick: false,
      donut: {
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    //pie chart bg
    colors: ["#18E482", "#252F3520", "#EFF4FB"],
  },
  tooltip: {
    enabled: false,
    theme: "dark",
  },
};

// export const pieChartData = [65, 35];

// Total Spent Default

export const lineChartDataTotalSpent = [
  {
    name: "סה״כ העברות",
    data: [34050, 42250, 27958, 31231, 54420, 78841, 85159],
  }
];

export let marinadaLineChartDataTotalSpent = [
  {
    name: "סה״כ העברות",
    data: [0, 2500 ,3500 ,4800],
  }
];

export let lineChartOptionsTotalSpent = {
  chart: {
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 10,
      left: 0,
      blur: 12,
      opacity: 0.2,
      color: "#38B2AC",
    },
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
    },
  },
  // line chart - teal to blue gradient
  colors: ["#38B2AC"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.5,
      gradientToColors: ["#4299E1"],
      opacityFrom: 0.6,
      opacityTo: 0.05,
      stops: [0, 90, 100],
    },
  },
  markers: {
    size: 5,
    colors: ["#38B2AC"],
    strokeColors: "#fff",
    strokeWidth: 2,
    strokeOpacity: 1,
    fillOpacity: 1,
    shape: "circle",
    radius: 2,
    hover: {
      size: 8,
    },
  },
  tooltip: {
    enabled: true,
    theme: "dark",
    style: {
      fontSize: "14px",
      fontFamily: "inherit",
    },
    y: {
      formatter: function(value) {
        return "₪" + value.toLocaleString();
      },
    },
    marker: {
      show: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    type: "line",
    width: 3,
  },
  xaxis: {
    type: "category",
    categories: [],
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    type: "numeric",
    show: true,
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
      },
      formatter: function(value) {
        if (value >= 1000000) {
          return "₪" + (value / 1000000).toFixed(0) + "M";
        }
        if (value >= 1000) {
          return "₪" + (value / 1000).toFixed(0) + "K";
        }
        return "₪" + value;
      },
    },
  },
  legend: {
    show: false,
  },
  grid: {
    show: true,
    strokeDashArray: 4,
    borderColor: "rgba(163, 174, 208, 0.2)",
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
};
